const { decodeRaw, getERC20ABI, BigNumberify } = require("./utils/utils");
const Http = require("./service/axios");
const {
  bufferToHex,
  bigIntToHex,
  toBuffer,
  intToHex,
} = require("@ethereumjs/util");
const { ethers, Contract, providers } = require("ethers");

class Chainge {
  constructor(ethereum, options = {}) {
    if (!options.signUrl) {
      throw "signUrl is required!";
    }
    this._appKey = options.appKey;
    this.expireTime = options.expireTime || 5000;
    this.signUrl = options.signUrl;

    this._ethereum = ethereum;
    this._SupportChains = [];
    this._rpcList = {};

    this.getAllExternalChainInfo();
  }

  /**
   * Static tool kit
   */
  static utils = {
    bufferToHex,
    bigIntToHex,
    toBuffer,
    intToHex,
  };

  /**
   * Decoding RAW data
   * @param {String} raw
   * @returns
   */
  static decodeRaw(raw) {
    return decodeRaw(raw);
  }

  /**
   * Get the balance
   * @param {String} walletAddress
   * @param {String[]} rpcUrls
   * @param {String} address
   * @returns
   */
  static async getBalance(walletAddress, rpcUrls, address, unitName = 18) {
    if (!walletAddress) {
      throw "Wallet address is required";
    }
    if (!(rpcUrls && rpcUrls.length > 0)) {
      throw "rpcUrls is empty";
    }
    let curProvider = null;
    for (let i = 0, leng = rpcUrls.length; i < leng; i++) {
      try {
        curProvider = new providers.JsonRpcProvider(rpcUrls[i]);
        if (curProvider) {
          break;
        }
      } catch (error) {
        continue;
      }
    }
    let balance = "0.0";
    let decimals = "18";
    if (address == "0xeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeee") {
      balance = await curProvider.getBalance(walletAddress);
    } else {
      const abi = getERC20ABI();
      const contract = new Contract(address, abi, curProvider);
      decimals = await contract.decimals();
      balance = await contract.balanceOf(walletAddress);
    }
    balance = ethers.utils.formatUnits(balance, decimals || unitName);
    return balance;
  }

  /**
   * Get basic transaction information based on txHash
   * @param {String} hash
   * @returns
   */
  static async getValueForHashRpc(rpc, hash, decimals) {
    const provider = new providers.JsonRpcProvider(rpc);
    try {
      const result = await provider.getTransaction(hash);
      if (!result) {
        throw "txhash error";
      }
      const isContractAddress = await provider.getCode(result.to);
      if (isContractAddress === "0x") {
        if (result.to !== "0x456325F2AC7067234dD71E01bebe032B0255e039") {
          throw "Hash error, place Check";
        }
        return {
          fromAddress: result.from,
          evmAddress: result.from,
          fromAmount: ethers.utils.formatEther(result.value),
          chainId: result.chainId,
        };
      } else {
        const tempData = result.data.substring(2);
        const transferStr = tempData.substring(0, 8);
        const address = tempData.substring(8, 72);
        const amountStr = tempData.substring(72);
        if (transferStr === "a9059cbb") {
          const abi = getERC20ABI();
          const contract = new Contract(result.to, abi, provider);
          decimals = await contract.decimals();

          const tempAmountStr = "0x" + amountStr.replace(/\b(0+)/gi, "");
          const amount = ethers.utils.formatUnits(
            BigNumberify(tempAmountStr),
            decimals
          );
          return {
            fromAddress: result.from,
            evmAddress: result.from,
            fromAmount: amount.toString(10),
            chainId: result.chainId,
            to: result.to,
          };
        }
      }
    } catch (error) {
      throw error;
    }
  }

  /**
   *
   * @param {*} fromChain
   * @param {*} mainChainId
   */
  _checkFromChain(fromChain, mainChainId) {
    if (this._SupportChains && this._SupportChains.length > 0) {
      const curChain = this._SupportChains.find(
        (item) => item.name === fromChain
      );
      if (curChain) {
        mainChainId = mainChainId + ''
        if(mainChainId.indexOf('0x') === -1) {
          mainChainId = intToHex(parseInt(mainChainId))
        }
        if (intToHex(curChain.chainId) !== mainChainId) {
          throw "main chain error";
        }
      }
    }
  }

  /**
   * @param {Object} bodyParams
   * @returns
   */
  async _getHeaders(bodyParams = {}) {
    let signature = "";
    let appKey = "";
    let _retryCount = 0;
    let timestamp = "";
    do {
      const result = await Http.getServerTime();
      timestamp = new Date().getTime();
      if (
        result.status === 200 &&
        result.data.code === 200 &&
        result.data.data &&
        result.data.data.serverTimeStamp
      ) {
        timestamp = result.data.data.serverTimeStamp;
      }
      try {
        let requestUrl = this.signUrl;
        if (this._appKey) {
          requestUrl = `${this.signUrl}?appKey=${this._appKey}`;
        }
        const signResult = await Http.getSign(
          requestUrl,
          { expiretime: this.expireTime, timestamp },
          bodyParams
        );
        signature = signResult.data.sign;
        appKey = signResult.data.appKey;
        break;
      } catch (error) {
        _retryCount++;
      }
    } while (_retryCount <= 3);

    const headers = {
      expireTime: this.expireTime,
      timestamp,
      signature: signature,
      appKey,
    };
    return headers;
  }

  async _checkHash(txHash, provider) {
    const result = await provider.getTransactionReceipt(txHash);
    if (result) {
      return Promise.resolve(true);
    } else {
      return await this._checkHash(txHash, provider);
    }
  }

  _getProvider(curChainName) {
    try {
      // let provider = null
      // if(this._ethereum.isTokenPocket) {
      //   const rpc = rpcList[curChainName][0]
      //   provider = ethers.getDefaultProvider(rpc)
      // } else {
      //   provider = new ethers.providers.Web3Provider(this._ethereum)
      // }
      let provider = new ethers.providers.Web3Provider(this._ethereum);
      return provider;
    } catch (error) {
      throw error;
    }
  }

  /**
   * Binding address
   * @param {Object} params
   * @param {String} params.bindAddress
   * @param {String} params.bindChain
   * @param {String} params.evmAddress
   * @param {String} params.signature
   * @returns
   */
  async bindAddress(params) {
    try {
      const headers = await this._getHeaders(params);
      const result = await Http.bindAddress(headers, params);
      return result.data;
    } catch (error) {
      throw error;
    }
  }

  /**
   * Check whether the signature is correct
   * @param {Object} params
   * @param {String} params.data
   * @returns
   */
  async checkSignatureRequest(params) {
    try {
      const headers = await this._getHeaders(params);
      const result = await Http.checkSignatureRequest(headers, params);
      return result.data;
    } catch (error) {
      throw error;
    }
  }

  /**
   * @returns
   */
  async getFeeToInfo() {
    try {
      const headers = await this._getHeaders();
      const result = await Http.getFeeToInfo(headers);
      return result.data;
    } catch (error) {
      throw error;
    }
  }

  /**
   * @param {Object} params
   * @param {Number} params.feeLevel
   * @param {String} params.feeToAddress
   * @returns
   */
  async setFeeToInfo(params) {
    try {
      const headers = await this._getHeaders(params);
      const result = await Http.setFeeToInfo(headers, params);
      return result.data;
    } catch (error) {
      throw error;
    }
  }

  /**
   * @returns
   */
  async getFeeLevelInfo() {
    try {
      const headers = await this._getHeaders();
      const result = await Http.getFeeLevelInfo(headers);
      return result.data;
    } catch (error) {
      throw error;
    }
  }

  /**
   * @returns
   */
  async getSupportChains() {
    try {
      // const headers = await this._getHeaders();
      const headers = {};
      const result = await Http.getSupportChains(headers);
      if (result.data.code === 200 && result.data.data.chains) {
        this._SupportChains = result.data.data.chains;
      }
      return result.data;
    } catch (error) {
      throw error;
    }
  }

  /**
   * @param {String} chain
   * @returns
   */
  async getSupportTokens(chain) {
    try {
      // let headers = await this._getHeaders();
      const headers = {};
      const result = await Http.getSupportTokens(headers, { chain: chain });
      return result.data;
    } catch (error) {
      throw error;
    }
  }

  /**
   *
   */
  async getAllExternalChainInfo() {
    try {
      const headers = {};
      const result = await Http.getAllExternalChainInfo(headers);
      if (result.data.code === 200 && result.data.data.externalChainInfo) {
        const tempObj = {};
        result.data.data.externalChainInfo.forEach((item) => {
          tempObj[item.name] = item.rpcUrls;
        });
        this._rpcList = tempObj;
      }
      return result.data;
    } catch (error) {
      throw error;
    }
  }

  /**
   *
   */
  async getTokenSortByKey() {
    try {
      const params = {
        key: this._appKey
      }
      const result = await Http.getTokenSortByKey(params);
      return result.data;
    } catch (error) {
      throw error;
    }
  }

  /**
   * @param {Object} params
   * @param {Number} params.feeLevel
   * @param {Number} params.fromAmount
   * @param {String} params.fromToken
   * @param {String} params.toChain
   * @param {String} params.toToken
   * @returns
   */
  async getAggregateQuote(params) {
    try {
      const headers = await this._getHeaders(params);
      const result = await Http.getAggregateQuote(headers, params);
      return result.data;
    } catch (error) {
      throw error;
    }
  }

  /**
   * @param {Object} params
   * @param {Number} params.amount
   * @param {Number} params.feeLevel
   * @param {String} params.fromChain
   * @param {String} params.toChain
   * @param {String} params.token
   * @returns
   */
  async getCrossChainQuote(params) {
    try {
      const headers = await this._getHeaders(params);
      const result = await Http.getCrossChainQuote(headers, params);
      return result.data;
    } catch (error) {
      throw error;
    }
  }

  /**
   * @param {String} sn
   * @returns
   */
  async getOrderDetail(sn) {
    try {
      if (!sn) {
        throw "sn is required!";
      }
      let headers = await this._getHeaders();
      const result = await Http.getOrderDetail(headers, { sn });
      return result.data;
    } catch (error) {
      throw error;
    }
  }

  /**
   * @param {Object} params
   * @param {Number} params.amount
   * @param {String} params.chain
   * @param {String} params.evmAddress
   * @param {String} params.fromAddress
   * @param {String} params.token
   * @returns
   */
  async getTransferToMinterRaw(params) {
    try {
      const headers = await this._getHeaders(params);
      const result = await Http.getTransferToMinterRaw(headers, params);
      return result.data;
    } catch (error) {
      throw error;
    }
  }

  /**
   * @param {Object} params
   * @param {Number} params.amount
   * @param {String} params.chain
   * @param {String} params.evmAddress
   * @param {String} params.fromAddress
   * @param {String} params.token
   * @returns
   */
  async getTransferToMinterParams(params) {
    try {
      const headers = await this._getHeaders(params);
      const result = await Http.getTransferToMinterParams(headers, params);
      return result.data;
    } catch (error) {
      throw error;
    }
  }

  /**
   * @param {Object} params
   * @param {String} params.certHash
   * @param {String} params.evmAddress
   * @param {Number} params.feeLevel
   * @param {String} params.fromAddress
   * @param {Number} params.fromAmount
   * @param {String} params.fromChain
   * @param {String} params.fromToken
   * @param {String} params.toChain
   * @param {String} params.toToken
   * @returns
   */
  async submitAggregate(params) {
    try {
      if (params.fromToken === params.toToken) {
        throw "error";
      }
      const headers = await this._getHeaders(params);
      const result = await Http.submitAggregate(headers, params);
      return result.data;
    } catch (error) {
      throw error;
    }
  }

  /**
   * @param {Object} params
   * @param {String} params.certHash
   * @param {String} params.evmAddress
   * @param {Number} params.feeLevel
   * @param {String} params.fromAddress
   * @param {Number} params.fromAmount
   * @param {String} params.fromChain
   * @param {String} params.fromToken
   * @param {String} params.toChain
   * @returns
   */
  async submitCrossChain(params) {
    try {
      if (params.fromChain === params.toChain) {
        throw "error";
      }
      const headers = await this._getHeaders(params);
      const result = await Http.submitCrossChain(headers, params);
      return result.data;
    } catch (error) {
      throw error;
    }
  }

  /**
   *
   * @param {Object} params
   * @param {String} params.chain
   * @param {String} params.evmAddress
   * @param {String} params.hash
   * @returns
   */
  async getOrderDetailByHashAndEvmAddress(params) {
    try {
      let headers = await this._getHeaders();
      const result = await Http.getOrderDetailByHashAndEvmAddress(
        headers,
        params
      );
      return result.data;
    } catch (error) {
      throw error;
    }
  }

  async _checkFromAddress(hash, requestParams) {
    try {
      const rpc = this._rpcList[requestParams.fromChain][0];
      const hashResult = await Chainge.getValueForHashRpc(rpc, hash, 18);
      if (
        hashResult.fromAddress.toLowerCase() ===
          requestParams.fromAddress.toLowerCase() &&
        hashResult.evmAddress.toLowerCase() ===
          requestParams.evmAddress.toLowerCase()
      ) {
        return true;
      } else {
        return false;
      }
    } catch (error) {
      throw error;
    }
  }

  async _sendTransaction(transactionParameters, callback) {
    try {
      if (callback && typeof callback === "function") {
        callback({ response: "start" }, "signAndSendTransaction");
      }
      const txHash = await this._ethereum.request({
        method: "eth_sendTransaction",
        params: [transactionParameters],
      });
      if (callback && typeof callback === "function") {
        callback({ response: "end" }, "signAndSendTransaction");
      }
      return txHash;
    } catch (error) {
      Http.setLog({
        uuid: 'version0.1.3',
        fromChain: '',
        step: 10,
        certHash: '',
        args: '',
        error: JSON.stringify(error),
      })
      throw error;
    }
  }

  async _waitForTransaction(txHash, params, callback) {
    try {
      if (callback && typeof callback === "function") {
        callback(
          {
            response: {
              status: "start",
            },
            certHash: txHash,
          },
          "waitForTransaction"
        );
      }
      const provider = this._getProvider(params.fromChain);
      const valid = await provider.waitForTransaction(txHash);
      if (callback && typeof callback === "function") {
        callback(
          {
            response: {
              status: "end",
              result: valid,
            },
            certHash: txHash,
          },
          "waitForTransaction"
        );
      }
      Http.setLog({
        uuid: 'version0.1.3',
        fromChain: params.fromChain,
        step: 12,
        certHash: txHash,
        args: JSON.stringify(params),
        error: JSON.stringify(valid) ,
      })
      if (valid && valid.status == 1) {
        return valid;
      } else {
        return null;
      }
    } catch (error) {
      Http.setLog({
        uuid: 'version0.1.3',
        fromChain: params.fromChain,
        step: 11,
        certHash: txHash,
        args: JSON.stringify(params),
        error: JSON.stringify(error),
      })
      throw error;
    }
  }

  /**
   * @param {Object} params
   * @param {string} params.evmAddress
   * @param {number} params.feeLevel
   * @param {string} params.fromAddress
   * @param {number} params.fromAmount
   * @param {string} params.fromChain
   * @param {string} params.fromToken
   * @param {string} params.toChain
   * @returns
   */
  async executeCrossChain(params, time = 10000, callback) {
    try {
      this._checkFromChain(params.fromChain, this._ethereum.chainId);
      let tempParams = {
        amount: params.fromAmount,
        chain: params.fromChain,
        evmAddress: params.evmAddress,
        fromAddress: params.fromAddress,
        token: params.fromToken,
      };
      const rawResult = await this.getTransferToMinterRaw(tempParams);
      if (rawResult.code !== 200) {
        return rawResult;
      }
      let raw = rawResult.data.raw;
      raw = raw.split("_")[0];
      const transactionParameters = Object.assign({}, decodeRaw(raw), {
        from: params.fromAddress,
      });

      const txHash = await this._sendTransaction(
        transactionParameters,
        callback
      );

      if (txHash) {
        params = Object.assign({}, params, { certHash: txHash });
        if (callback && typeof callback === "function") {
          callback(
            Object.assign({}, { response: params, certHash: txHash }),
            "crossChain"
          );
        }
        const valid = await this._waitForTransaction(txHash, params, callback);
        if (!valid) return;
        return await this.executeCrossChainByHash(
          params,
          time,
          (res, type, txHash) => {
            callback(
              Object.assign({}, { response: res, certHash: txHash }),
              type
            );
          },
          true
        );
      } else {
        return "";
      }
    } catch (error) {
      throw error;
    }
  }

  /**
   * @param {Object} params
   * @param {string} params.certHash
   * @param {string} params.evmAddress
   * @param {number} params.feeLevel
   * @param {string} params.fromAddress
   * @param {number} params.fromAmount
   * @param {string} params.fromChain
   * @param {string} params.fromToken
   * @param {string} params.toChain
   * @returns
   */
  async executeCrossChainByHash(params, time = 10000, callback, _priv) {
    try {
      const tempParams = {
        certHash: params.certHash,
        evmAddress: params.evmAddress,
        feeLevel: params.feeLevel,
        fromAddress: params.fromAddress,
        fromAmount: params.fromAmount,
        fromChain: params.fromChain,
        fromToken: params.fromToken,
        toChain: params.toChain,
      };
      const hashResult = await this._checkFromAddress(
        params.certHash,
        tempParams
      );
      if (!hashResult) {
        throw "FromAddress is different";
      }
      if (!_priv) {
        callback(
          Object.assign({}, { response: params, certHash: params.certHash }),
          "crossChain"
        );
      }
      const orderResult = await this.submitCrossChain(tempParams);
      if (callback && typeof callback === "function") {
        if (_priv) {
          callback(orderResult, "submit", params.certHash);
        } else {
          callback(
            Object.assign(
              {},
              { certHash: params.certHash, response: orderResult }
            ),
            "submit",
            params.certHash
          );
        }
      }
      if (orderResult.code !== 200) {
        return orderResult;
      }
      const sn = orderResult.data.sn;
      let tempCount = 0;
      const subscribe = async (cb) => {
        const detail = await this.getOrderDetail(sn);
        cb(detail);
        if (detail && detail.code === 200) {
          if (detail.data.order.status < 2) {
            const timer = setTimeout(() => {
              clearTimeout(timer);
              subscribe(cb);
            }, time);
          }
        } else {
          if (tempCount <= 3) {
            tempCount++;
            subscribe(cb);
          }
        }
      };
      return subscribe;
    } catch (error) {
      throw error;
    }
  }

  /**
   * @param {Object} params
   * @param {String} params.evmAddress
   * @param {Number} params.feeLevel
   * @param {String} params.fromAddress
   * @param {Number} params.fromAmount
   * @param {String} params.fromChain
   * @param {String} params.fromToken
   * @param {String} params.toChain
   * @param {String} params.toToken
   * @returns
   */
  async executeAggregate(params, time = 10000, callback) {
    try {
      this._checkFromChain(params.fromChain, this._ethereum.chainId);
      let tempParams = {
        amount: params.fromAmount,
        chain: params.fromChain,
        evmAddress: params.evmAddress,
        fromAddress: params.fromAddress,
        token: params.fromToken,
      };
      const rawResult = await this.getTransferToMinterRaw(tempParams);
      if (rawResult.code !== 200) {
        return rawResult;
      }
      let raw = rawResult.data.raw;
      raw = raw.split("_")[0];
      const transactionParameters = Object.assign({}, decodeRaw(raw), {
        from: params.fromAddress,
      });

      const txHash = await this._sendTransaction(
        transactionParameters,
        callback
      );

      if (txHash) {
        params = Object.assign({}, params, { certHash: txHash });
        if (callback && typeof callback === "function") {
          callback(
            Object.assign({}, { response: params, certHash: txHash }),
            "aggregate"
          );
        }

        const valid = await this._waitForTransaction(txHash, params, callback);
        if (!valid) return;
        return await this.executeAggregateByHash(
          params,
          time,
          (res, type, txHash) => {
            callback(
              Object.assign({}, { response: res, certHash: txHash }),
              type
            );
          },
          true
        );
      } else {
        return "";
      }
    } catch (error) {
      throw error;
    }
  }

  /**
   * @param {Object} params
   * @param {String} params.certHash
   * @param {String} params.evmAddress
   * @param {Number} params.feeLevel
   * @param {String} params.fromAddress
   * @param {Number} params.fromAmount
   * @param {String} params.fromChain
   * @param {String} params.fromToken
   * @param {String} params.toChain
   * @param {String} params.toToken
   * @returns
   */
  async executeAggregateByHash(params, time = 10000, callback, _priv) {
    try {
      const tempParams = {
        certHash: params.certHash,
        evmAddress: params.evmAddress,
        feeLevel: params.feeLevel,
        fromAddress: params.fromAddress,
        fromAmount: params.fromAmount,
        fromChain: params.fromChain,
        fromToken: params.fromToken,
        toChain: params.toChain,
        toToken: params.toToken,
      };
      const hashResult = await this._checkFromAddress(
        params.certHash,
        tempParams
      );
      if (!hashResult) {
        throw "FromAddress is different";
      }
      if (!_priv) {
        callback(
          Object.assign({}, { response: params, certHash: params.certHash }),
          "aggregate"
        );
      }
      const orderResult = await this.submitAggregate(tempParams);
      if (callback && typeof callback === "function") {
        if (_priv) {
          callback(orderResult, "submit", params.certHash);
        } else {
          callback(
            Object.assign(
              {},
              { certHash: params.certHash, response: orderResult }
            ),
            "submit",
            params.certHash
          );
        }
      }
      if (orderResult.code !== 200) {
        return orderResult;
      }
      const sn = orderResult.data.sn;
      let tempCount = 0;
      const subscribe = async (cb) => {
        const detail = await this.getOrderDetail(sn);
        cb(detail);
        if (detail && detail.code === 200) {
          if (detail.data.order.status < 2) {
            const timer = setTimeout(() => {
              clearTimeout(timer);
              subscribe(cb);
            }, time);
          }
        } else {
          if (tempCount <= 3) {
            tempCount++;
            subscribe(cb);
          }
        }
      };
      return subscribe;
    } catch (error) {
      throw error;
    }
  }

  /**
   * @param {Object} params
   * @param {String} params.certHash
   * @param {String} params.evmAddress
   * @param {Number} params.feeLevel
   * @param {String} params.fromAddress
   * @param {Number} params.fromAmount
   * @param {String} params.fromChain
   * @param {String} params.fromToken
   * @param {String} params.toChain
   * @param {String} params.toToken
   * @returns
   */
  async executeByHash(params, time = 10000, callback) {
    Object.freeze(params);
    console.log("sdk executeByHash:", params);
    if (
      params.fromChain !== params.toChain &&
      params.fromToken === params.toToken
    ) {
      return await this.executeCrossChainByHash(params, time, callback);
    } else {
      if (params.fromToken !== params.toToken) {
        return await this.executeAggregateByHash(params, time, callback);
      } else {
        throw "error";
      }
    }
  }

  /**
   * @param {Object} params
   * @param {String} params.evmAddress
   * @param {Number} params.feeLevel
   * @param {String} params.fromAddress
   * @param {Number} params.fromAmount
   * @param {String} params.fromChain
   * @param {String} params.fromToken
   * @param {String} params.toChain
   * @param {String} params.toToken
   * @returns
   */
  async execute(params, time = 10000, callback) {
    Object.freeze(params);
    console.log("sdk execute:", params);
    this._checkFromChain(params.fromChain, this._ethereum.chainId);
    if (
      params.fromChain !== params.toChain &&
      params.fromToken === params.toToken
    ) {
      return await this.executeCrossChain(params, time, callback);
    } else {
      if (params.fromToken !== params.toToken) {
        return await this.executeAggregate(params, time, callback);
      } else {
        throw "error";
      }
    }
  }
}

module.exports = Chainge;
